import React from 'react'

const Badge = props => (
  <svg
    height={props.height}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24.7 27"
  >
    <defs>
      <clipPath id="badge4_a">
        <circle cx="12.4" cy="11.8" r="8" fill="none" />
      </clipPath>
    </defs>
    <g data-name="Warstwa 2">
      <circle cx="12.4" cy="11.8" r="8" fill="#00b4ff" />
      <path
        d="M12.2.8c.3 0 .7-.5 1-.5s.6.6.8.6.8-.4 1-.3.5.6.8.7.8-.2 1-.1.4.7.6.8.8 0 1 0 .3.8.5 1 .9 0 1 .2.2.8.3 1 .9.2 1 .4 0 .8.2 1 .8.3.9.6-.2.8 0 1 .7.4.8.7-.3.8-.2 1 .7.5.7.8-.4.7-.4 1 .6.6.6.9-.5.6-.5.9.4.7.4 1-.7.6-.7.8.3.8.2 1-.7.4-.8.7.2.8 0 1-.7.4-.8.6 0 .8-.1 1-.8.2-1 .4-.1.9-.3 1-.8.1-1 .3-.2.8-.5 1-.8-.1-1 0-.4.8-.6.9-.8-.2-1-.1-.6.7-.8.7-.8-.3-1-.3-.6.7-.9.7-.6-.5-1-.5-.6.5-.9.5-.6-.6-.9-.6-.7.4-1 .3-.5-.7-.7-.7-.8.2-1 .1-.4-.7-.6-.9-.9.2-1.1 0-.3-.7-.5-.9-.8 0-1-.2-.1-.8-.3-1-.8-.2-1-.4 0-.8-.1-1-.8-.3-1-.5.2-.9 0-1.1-.7-.4-.8-.7.3-.8.2-1-.6-.5-.7-.8.4-.7.4-1-.5-.6-.5-.9.5-.6.5-.9-.5-.7-.4-1 .6-.6.7-.8-.3-.8-.3-1 .8-.5.9-.7-.3-.8-.1-1 .7-.4.9-.6 0-.9 0-1 .9-.2 1-.4.2-.9.4-1 .8 0 1-.2.2-.9.4-1 .9 0 1.1-.1.3-.8.6-1 .8.3 1 .2.5-.7.8-.8.7.4 1 .3.6-.6.8-.6.7.5 1 .5z"
        fill="#00b4ff"
      />
      <circle cx="12.3" cy="11.8" r="10.9" fill="#00b4ff" />
      <path
        d="M20.6 11.8a8.3 8.3 0 1 1-8.3-8.3 8.3 8.3 0 0 1 8.3 8.3zM7.9 3.3l.4-.2.2.4a1.5 1.5 0 0 1-.3.3.5.5 0 0 1-.4 0 .5.5 0 0 1-.2-.3.5.5 0 0 1-.1-.4.5.5 0 0 1 .3-.3H8V3a.5.5 0 0 0-.2 0 .2.2 0 0 0-.2.2.3.3 0 0 0 0 .2.3.3 0 0 0 .3.2.2.2 0 0 0 .2 0v-.2H8zM8.9 3l.1.4h-.3l-.3-.8.3-.1q.4-.2.5 0a.3.3 0 0 1 0 .4l.3.3-.3.1L9 3zM8.8 3s.1-.1 0-.2zM10.3 3l-.2-.2-.2.1v.2h-.3v-1h.4l.6.8zm-.3-.4v-.2l-.1-.1v.4zM11.1 2.8h-.3v-.7h-.3v-.2l.7-.1V2H11zM12.3 1.8v.6a.4.4 0 0 1-.1.3.5.5 0 0 1-.3 0 .4.4 0 0 1-.3 0 .4.4 0 0 1-.1-.3v-.6h.2v.6a.2.2 0 0 0 0 .1.2.2 0 0 0 .2 0 .1.1 0 0 0 .1 0 .3.3 0 0 0 0-.2v-.5zM12.6 2.8v-1h.3v.7h.4v.2zM14 3v-.3h-.3v.1h-.4l.5-.9h.3l.2 1zm0-.5v-.2-.1a.7.7 0 0 1 0-.1l-.1.4zM15 2.4a.4.4 0 0 0-.2.2l.1.3h.2V3a.5.5 0 0 1-.2 0 .4.4 0 0 1-.3-.2.5.5 0 0 1 0-.4.5.5 0 0 1 0-.2.4.4 0 0 1 .3-.2.5.5 0 0 1 .3 0 .7.7 0 0 1 .2.2l-.1.1h-.1zM15.2 3.5H15v-.2a.1.1 0 0 0 .2 0 .3.3 0 0 0 0-.2l.4-.8h.2l-.3 1a.5.5 0 0 1-.2.2.3.3 0 0 1-.2 0zM16.4 3.7l-.5-.3.4-.8.5.2-.1.2-.3-.1V3l.2.1v.2l-.4-.1v.2h.3zM16.6 3.7a.1.1 0 0 1 .2 0 .1.1 0 0 1 0 .2.1.1 0 0 1-.1 0 .1.1 0 0 1-.1-.1.1.1 0 0 1 0-.1zm.3-.1l-.2-.1.3-.6.3.2zM5.6 18.4a.3.3 0 0 1-.3.1.4.4 0 0 1-.2-.1l-.2.1-.2-.2.7-.6.2.2a.4.4 0 0 1 .2.3.3.3 0 0 1-.2.2zm-.4-.2a.1.1 0 0 0 .2 0v-.1zM5.7 19l-.2.2-.2-.2.6-.7.2.2c.3.2.3.3.2.5a.3.3 0 0 1-.3 0l-.1.6-.2-.2V19zm.1-.2a.1.1 0 0 0 .2 0v-.2zM7 19.8a.5.5 0 0 1-.3.3.4.4 0 0 1-.3-.1.4.4 0 0 1-.3-.3.5.5 0 0 1 .2-.4.5.5 0 0 1 .3-.2.5.5 0 0 1 .4 0 .4.4 0 0 1 .2.4.5.5 0 0 1-.2.3zm-.6-.4v.4a.2.2 0 0 0 .2 0 .4.4 0 0 0 .2-.2.3.3 0 0 0 0-.2.1.1 0 0 0 0-.1l-.3.1zM7.6 20l.4.3-.3.4a1 1 0 0 1-.4-.1.5.5 0 0 1-.2-.3.6.6 0 0 1 .4-.6.5.5 0 0 1 .4 0 .6.6 0 0 1 .1.2.5.5 0 0 1 .1 0l-.2.2a.7.7 0 0 0-.1-.2.3.3 0 0 0-.2 0 .3.3 0 0 0-.2.2.4.4 0 0 0 0 .2.2.2 0 0 0 .1.1h.1v-.2zM8.3 20.7l-.1.3-.3-.1.4-.9.3.1c.3.1.3.3.3.5a.3.3 0 0 1-.3.1v.5h-.2v-.5zm0-.2a.1.1 0 0 0 .3 0l-.1-.2zM9.4 21.5v-.2l-.3-.1v.1h-.4l.6-.9.4.1v1zm0-.4v-.2-.1-.2.1l-.2.3zM10.3 21.7V21v.3l-.2.4H10l.2-1h.3l.1.7.3-.6h.4l-.2 1h-.2v-.3-.1-.2l-.3.6zM11.3 21.9v-1h.3v1zM12.4 21.6a.2.2 0 0 1 0 .2.3.3 0 0 1-.2 0 .4.4 0 0 1-.2 0H11.7v-.2a.4.4 0 0 0 .2 0h.2l-.1-.1a.4.4 0 0 1-.1 0 .2.2 0 0 1-.1-.2.2.2 0 0 1 0-.1.3.3 0 0 1 0-.2.5.5 0 0 1 .4 0 .8.8 0 0 1 .3 0l-.1.2a.9.9 0 0 0-.3 0h.1a.5.5 0 0 1 .2.2.2.2 0 0 1 0 .2zM13 21.9h-.2V21h-.2V21h.7v.2H13zM14.1 21.8l-.1-.2h-.3v.2h-.3l.2-1h.3l.5.9zm-.2-.4v-.2a.5.5 0 0 1 0-.1l-.1-.1v.4zM15.5 21.4v-.2l-.4.1v.2l-.3.1v-1h.4l.6.7zm-.2-.3v-.2l-.2-.1v-.1.4z"
        fill="#fff"
      />
      <path
        d="M16.4 21l-.5-.5a2 2 0 0 1 .1.3l.2.3-.2.1-.4-.8.3-.2.5.6-.1-.8.3-.1.4.9h-.2l-.2-.3v-.3.8zM17.8 20.3h-.4v.3l-.2.1-.3-1 .3-.2.8.7zm-.3-.3h-.2v-.2h-.1a2.8 2.8 0 0 1 0 .4zM18.5 19.8l-.2.2-.5-.6-.2.1v-.2l.5-.4.1.2-.2.1zM19.2 18.6a.5.5 0 0 1 .2.3.5.5 0 0 1-.2.4.5.5 0 0 1-.3.1.6.6 0 0 1-.6-.6.5.5 0 0 1 .2-.3.5.5 0 0 1 .4-.1.5.5 0 0 1 .3.2zm-.5.4c.1.2.3.2.4.1a.1.1 0 0 0 0-.1.4.4 0 0 0-.1-.2.4.4 0 0 0-.2-.2.2.2 0 0 0-.1 0c-.1.2-.1.3 0 .4zM19.6 18.3l.3.2-.2.3-.7-.7.2-.2c.2-.2.4-.3.5-.1a.3.3 0 0 1 0 .3h.6l-.2.3-.4-.1zm-.1-.1a.1.1 0 0 0 0-.2h-.2z"
        fill="#fff"
      />
      <circle cx="22" cy="11.7" r=".5" fill="#fff" />
      <circle cx="21.9" cy="13.5" r=".4" fill="#fff" />
      <circle cx="21.5" cy="15.1" r=".3" fill="#fff" opacity=".5" />
      <circle cx="21.9" cy="9.9" r=".4" fill="#fff" />
      <circle cx="21.5" cy="8.3" r=".3" fill="#fff" />
      <circle cx="2.8" cy="11.7" r=".5" fill="#fff" />
      <circle cx="2.9" cy="13.5" r=".4" fill="#fff" />
      <circle cx="3.3" cy="15.1" r=".3" fill="#fff" />
      <circle cx="2.9" cy="9.9" r=".4" fill="#fff" />
      <circle cx="3.3" cy="8.3" r=".3" fill="#fff" opacity=".5" />
      <circle cx="12.4" cy="11.8" r="8" fill="#fbc53b" />
      <g clip-path="url(#badge4_a)">
        <path fill="#fbc53b" d="M1.6 2.6h21.8v21.8H1.6z" />
        <ellipse
          cx="12.6"
          cy="25.2"
          rx="6.1"
          ry="1.8"
          fill="#34dce7"
          opacity=".1"
        />
        <ellipse
          cx="12.6"
          cy="24.7"
          rx="4.4"
          ry="1.3"
          fill="#34dce7"
          opacity=".1"
        />
        <ellipse
          cx="12.6"
          cy="24.6"
          rx="3.3"
          ry="1"
          fill="#34dce7"
          opacity=".1"
        />
        <path fill="#43302b" d="M3.4 15.9h17.9v.4H3.4z" />
        <rect x="6.4" y="6.7" width="12.2" height="8.3" rx=".3" fill="#fff" />
        <path
          d="M18.2 6.7H6.7a.3.3 0 0 0-.3.4v7h12.2v-7a.3.3 0 0 0-.4-.4z"
          fill="#e6e6e6"
        />
        <path
          d="M18.2 6.7H6.7a.3.3 0 0 0-.3.4.3.3 0 0 1 .3-.4h11.5a.3.3 0 0 1 .4.4.3.3 0 0 0-.4-.4z"
          fill="#479ee8"
        />
        <path fill="#15081f" d="M6.8 7.3H18V14H6.8z" />
        <rect x="8.3" y="8.1" width="6.5" height=".2" rx=".1" fill="#0090c5" />
        <rect x="7.2" y="7.6" width="4.3" height=".2" rx=".1" fill="#0090c5" />
        <rect x="7.2" y="8.1" width=".6" height=".2" rx=".1" fill="#34dce7" />
        <rect x="7.3" y="8.6" width="3.4" height=".1" rx=".1" fill="#dbb90e" />
        <rect x="7.3" y="9" width="3.4" height=".1" rx=".1" fill="#dbb90e" />
        <rect x="7.3" y="9.4" width="3.4" height=".1" rx=".1" fill="#dbb90e" />
        <rect x="7.3" y="9.8" width="3.4" height=".1" rx=".1" fill="#dbb90e" />
        <rect x="7.3" y="10.2" width=".6" height=".1" rx=".1" fill="#dbff0e" />
        <rect x="8.2" y="10.2" width=".6" height=".1" rx=".1" fill="#dbb90e" />
        <rect x="9" y="10.2" width=".6" height=".1" rx=".1" fill="#dbb90e" />
        <rect x="9.9" y="10.2" width=".6" height=".1" rx=".1" fill="#dbb90e" />
        <rect x="10.8" y="10.2" width=".6" height=".1" rx=".1" fill="#dbb90e" />
        <rect x="11.6" y="10.2" width=".6" height=".1" rx=".1" fill="#dbff0e" />
        <rect x="7.3" y="10.6" width="3.4" height=".1" rx=".1" fill="#dbb90e" />
        <rect x="13.2" y="9.2" width="4.2" height=".1" rx=".1" fill="#ff551f" />
        <rect x="13.2" y="9.8" width="4.2" height=".1" rx=".1" fill="#ff551f" />
        <rect
          x="13.2"
          y="10.4"
          width="4.2"
          height=".1"
          rx=".1"
          fill="#ff551f"
        />
        <rect
          x="13.2"
          y="10.9"
          width="4.2"
          height=".1"
          rx=".1"
          fill="#ff551f"
        />
        <rect
          x="13.2"
          y="11.5"
          width="4.2"
          height=".1"
          rx=".1"
          fill="#ff551f"
        />
        <rect
          x="13.2"
          y="12.1"
          width="2.2"
          height=".1"
          rx=".1"
          fill="#ff551f"
        />
        <rect
          x="14.6"
          y="12.4"
          width="2.2"
          height=".1"
          rx=".1"
          fill="#ff551f"
        />
        <rect
          x="14.6"
          y="12.8"
          width="2.2"
          height=".1"
          rx=".1"
          fill="#ff551f"
        />
        <rect x="7.8" y="12.8" width="1.1" height=".1" rx=".1" fill="#ff2995" />
        <rect x="7.8" y="12.5" width="1.1" height=".1" rx=".1" fill="#ff2995" />
        <rect x="7.8" y="12.2" width="1.1" height=".1" rx=".1" fill="#ff2995" />
        <rect x="7.8" y="11.8" width="1.1" height=".1" rx=".1" fill="#ff2995" />
        <rect x="9.3" y="11.8" width=".4" height=".1" rx=".1" fill="#ff2995" />
        <rect x="9.3" y="12.6" width=".4" height=".1" rx=".1" fill="#ff2995" />
        <path fill="#feb187" d="M11.9 11.8h1.3v.9h-1.3z" />
        <path
          d="M11.9 12.5a1.8 1.8 0 0 0 1.2 0v.3h-.6l-.6-.1z"
          fill="#f88b65"
        />
        <rect
          x="10.4"
          y="17.5"
          width="4.2"
          height="1.8"
          rx=".6"
          fill="#e99700"
        />
        <path
          d="M14.6 18.5a7.7 7.7 0 0 1-4.2 0 .8.8 0 0 0 .9.7h2.4a.9.9 0 0 0 .9-.7z"
          fill="#e97800"
        />
        <path
          d="M12.7 9l.9-.9a1 1 0 0 1 0 .9l.3-.4a.7.7 0 0 1-.1.8L14 9a.9.9 0 0 1-.5 1z"
          fill="#593730"
        />
        <path d="M13.4 9.9h.3a1.2 1.2 0 0 0-.8-1.1l-.2.2z" fill="#481715" />
        <circle cx="13.5" cy="10.8" r=".4" fill="#feb187" />
        <circle cx="11.5" cy="10.8" r=".4" fill="#feb187" />
        <rect x="11.3" y="9" width="2.4" height="3.4" rx="1.2" fill="#593730" />
        <path
          fill="#481715"
          d="M11.5 11v.2l.2-.1.1.1.1-.1h.1v-.3.3-.1l-.2.1-.1-.1h-.1zM12.1 10.4v.4l.2-.2.1.1.2-.1.1.1v-.4.3l-.1-.1-.2.1-.1-.1h-.1l-.1-.1zM13 11.3v.2l.2-.1v.1h.2v-.3.2H13v-.1z"
        />
        <path
          fill="#593730"
          d="M12.2 12.2v.3l.1-.1.1.1h.2v-.3h-.4zM12.6 12.2v.2H13v-.2h-.3z"
        />
        <path
          fill="#593730"
          d="M12 12.2v.2h.2v-.3H12zM11.7 9.3l-.3-.3v.3h-.2l.2.2h-.2l.2.2h.3v-.4z"
        />
        <path fill="#feb187" d="M9.7 15.1l-.1.8h.8V15l-.6-.1" />
        <path fill="#dc9266" d="M10.2 15.3h-.5V15l.5.2z" />
        <path
          d="M11 13c-.5.3-1 .4-1.6 2l1 .4A14.8 14.8 0 0 0 11 13z"
          fill="#2e63ca"
        />
        <path fill="#feb187" d="M15.2 15.1l.2.8h-.8V15l.5-.1" />
        <path fill="#dc9266" d="M14.7 15.3h.6V15l-.6.2z" />
        <path
          d="M13.8 13c.6.3 1.1.4 1.7 2l-1 .4a14.8 14.8 0 0 1-.7-2.4z"
          fill="#2e63ca"
        />
        <path
          d="M12.8 18.5H12a1.5 1.5 0 0 1-1.7-1.7l-.2-2.2a2 2 0 0 1 2-2h.6a2 2 0 0 1 1.9 2l-.3 2.1c0 1.4-.6 1.8-1.6 1.8z"
          fill="#2e7fdb"
        />
        <path
          d="M14 13.1a14.2 14.2 0 0 1-3.2 0 2 2 0 0 0-.6 1h1l1 .2h2l.4-.4a2 2 0 0 0-.6-.8z"
          fill="#2e63ca"
        />
        <path
          d="M11 24.4l.5.1.6-.1c0-.1-.3-.3-.6-.3s-.5 0-.5.3z"
          fill="#224dc2"
        />
        <path d="M10.7 19.2l.8 5a1 1 0 0 0 .6 0v-3.8z" fill="#b7ffe7" />
        <path d="M12 20.5l-1.1-.2.1.9c.2 0 .8-.3 1 .4v-1z" fill="#e99700" />
        <path
          d="M14 24.4l-.5.1-.6-.1c0-.1.3-.3.6-.3s.5 0 .5.3z"
          fill="#224dc2"
        />
        <path d="M14.3 19.2l-.9 5a1 1 0 0 1-.5 0v-3.8z" fill="#b7ffe7" />
        <path
          d="M12.9 20.5h.1l1.1-.2-.1.9c-.2 0-.8-.3-1 .4v-1z"
          fill="#e99700"
        />
        <rect
          x="10.8"
          y="21.8"
          width="3.5"
          height=".3"
          rx=".1"
          transform="rotate(-90 12.5 22)"
          fill="#2273db"
        />
        <path
          d="M12.5 20.1a.4.4 0 0 1 .4.4v.8a.5.5 0 0 1-.4.5.5.5 0 0 1-.5-.5v-.7a.5.5 0 0 1 .5-.5z"
          fill="#22a4fd"
        />
        <path
          d="M13 20.6a1 1 0 0 0-1 0v-.3a1 1 0 0 1 1 0z"
          fill="#224dc2"
          opacity=".7"
        />
        <path
          d="M10.4 19.3h-.6a1.4 1.4 0 0 1 0-2.8.1.1 0 0 1 .2.1.2.2 0 0 1-.2.2 1 1 0 1 0 0 2.1h.6a.2.2 0 1 1 0 .4z"
          fill="#662d91"
        />
        <rect x="9.2" y="16.3" width="1" height=".5" rx=".3" fill="#93278f" />
        <path
          d="M9.5 16.4h.5a.3.3 0 0 1 .3.2.3.3 0 0 0-.3-.3h-.5a.3.3 0 0 0-.3.3.3.3 0 0 1 .3-.3zM14.5 19.3h.6a1.4 1.4 0 0 0 0-2.8.2.2 0 0 0-.2.1.2.2 0 0 0 .2.2 1 1 0 0 1 0 2.1h-.6a.2.2 0 0 0 0 .4z"
          fill="#662d91"
        />
        <rect
          x="14.7"
          y="16.3"
          width="1"
          height=".5"
          rx=".3"
          transform="rotate(-180 15.2 16.6)"
          fill="#93278f"
        />
        <path
          d="M15.4 16.4H15a.3.3 0 0 0-.2.2.3.3 0 0 1 .2-.3h.5a.3.3 0 0 1 .3.3.3.3 0 0 0-.3-.3z"
          fill="#662d91"
        />
        <rect
          x="9.6"
          y="18.8"
          width="5.8"
          height="1.3"
          rx=".6"
          fill="#04424c"
        />
        <path
          d="M10.2 18.9h4.5a.6.6 0 0 1 .7.6.6.6 0 0 0-.7-.6h-4.5a.6.6 0 0 0-.6.6.6.6 0 0 1 .6-.6z"
          fill="#04254c"
        />
        <path
          d="M13.3 18.3h-1.7a1.2 1.2 0 0 1-1.1-1.2l-.3-2.6a1.2 1.2 0 0 1 1.1-1.1h2.4a1.2 1.2 0 0 1 1.1 1.1l-.4 2.6a1.2 1.2 0 0 1-1.2 1.2z"
          fill="#04424c"
        />
        <path
          d="M11.3 13.4h2.3a1.2 1.2 0 0 1 1.2 1.1 1.2 1.2 0 0 0-1.2-1.1h-2.3a1.2 1.2 0 0 0-1.1 1.2 1.2 1.2 0 0 1 1.1-1.2z"
          fill="#04254c"
        />
        <rect
          x="10.2"
          y="19.8"
          width="4.5"
          height=".6"
          rx=".3"
          fill="#04254c"
        />
        <rect
          x="11.3"
          y="20.3"
          width="2.4"
          height=".6"
          rx=".2"
          fill="#04424c"
        />
        <path
          d="M10.5 19.8h4a.3.3 0 0 1 .3.2.3.3 0 0 0-.3-.2h-4a.3.3 0 0 0-.3.2.3.3 0 0 1 .3-.2z"
          fill="#2293f0"
        />
        <rect
          x="10.6"
          y="20.2"
          width="3.8"
          height=".3"
          rx=".1"
          fill="#04254c"
        />
        <path
          d="M10.8 20.2h3.4a.1.1 0 0 1 .2.1.1.1 0 0 0-.2-.1h-3.4a.1.1 0 0 0-.2.1.1.1 0 0 1 .2-.1z"
          fill="#22b2ff"
        />
        <path
          d="M12.2 23.9v-.4a.3.3 0 0 1 .3-.3.3.3 0 0 1 .2.3v.4"
          fill="#22a4fd"
        />
        <path
          d="M10.6 24.4a.1.1 0 0 1 0-.1.1.1 0 0 1 0-.1 4.8 4.8 0 0 1 4 0 .1.1 0 0 1-.2.2 4.6 4.6 0 0 0-3.8 0z"
          fill="#2273db"
        />
        <rect x="12.1" y="23.7" width=".9" height=".3" rx=".1" fill="#224dc2" />
        <rect x="12.4" y="23.8" width=".1" height=".9" rx=".1" fill="#2273db" />
        <rect x="12.3" y="24.4" width=".4" height=".7" rx=".2" fill="#34dce7" />
        <circle cx="14.6" cy="24.5" r=".3" fill="#34dce7" />
        <path
          d="M14.6 24.1a.4.4 0 0 1 .4.4.4.4 0 1 0-.7 0 .3.3 0 0 1 .3-.4z"
          fill="#7ff"
        />
        <circle cx="14.6" cy="24.5" r=".2" fill="#27b0d7" />
        <circle cx="14.6" cy="24.5" r=".1" fill="#2273db" />
        <path d="M14.6 24.4h0z" fill="#5fffff" />
        <circle cx="10.5" cy="24.5" r=".3" fill="#34dce7" />
        <path
          d="M10.5 24.1a.3.3 0 0 1 .4.4.3.3 0 0 0-.4-.4.4.4 0 0 0-.3.4.3.3 0 0 1 .3-.4z"
          fill="#7ff"
        />
        <circle cx="10.5" cy="24.5" r=".2" fill="#27b0d7" />
        <circle cx="10.5" cy="24.5" r=".1" fill="#2273db" />
        <path d="M10.5 24.4z" fill="#5fffff" />
        <rect x="11.3" y="15" width="2.4" height="1.1" rx=".6" fill="#224dc2" />
        <path
          d="M13.1 15H12a.6.6 0 0 0-.6.6.6.6 0 0 1 .6-.6H13a.6.6 0 0 1 .6.6.6.6 0 0 0-.6-.6z"
          fill="#226ee5"
        />
        <rect
          x="12.2"
          y="15.4"
          width=".6"
          height="4.6"
          rx=".2"
          fill="#111f9a"
        />
        <rect x="12.3" y="15.7" width=".4" height=".1" rx="0" fill="#1159c9" />
        <rect x="12.3" y="15.7" width=".4" height=".1" rx="0" fill="#111b54" />
        <rect x="12.3" y="16" width=".4" height=".1" rx="0" fill="#1159c9" />
        <rect x="12.3" y="16" width=".4" height=".1" rx="0" fill="#111b54" />
        <rect x="12.3" y="16.3" width=".4" height=".1" rx="0" fill="#1159c9" />
        <rect x="12.3" y="16.3" width=".4" height=".1" rx="0" fill="#111b54" />
        <rect x="12.3" y="16.7" width=".4" height=".1" rx="0" fill="#1159c9" />
        <rect x="12.3" y="16.7" width=".4" height=".1" rx="0" fill="#111b54" />
        <rect x="12.3" y="17" width=".4" height=".1" rx="0" fill="#1159c9" />
        <rect x="12.3" y="17" width=".4" height=".1" rx="0" fill="#111b54" />
        <rect x="12.3" y="17.3" width=".4" height=".1" rx="0" fill="#1159c9" />
        <rect x="12.3" y="17.3" width=".4" height=".1" rx="0" fill="#111b54" />
        <rect x="12.3" y="17.6" width=".4" height=".1" rx="0" fill="#1159c9" />
        <rect x="12.3" y="17.6" width=".4" height=".1" rx="0" fill="#111b54" />
        <rect x="12.3" y="17.9" width=".4" height=".1" rx="0" fill="#1159c9" />
        <rect x="12.3" y="17.9" width=".4" height=".1" rx="0" fill="#111b54" />
        <rect x="12.3" y="18.2" width=".4" height=".1" rx="0" fill="#1159c9" />
        <rect x="12.3" y="18.2" width=".4" height=".1" rx="0" fill="#111b54" />
        <rect x="12.3" y="18.5" width=".4" height=".1" rx="0" fill="#1159c9" />
        <rect x="12.3" y="18.5" width=".4" height=".1" rx="0" fill="#111b54" />
        <rect x="12.3" y="18.8" width=".4" height=".1" rx="0" fill="#1159c9" />
        <rect x="12.3" y="18.8" width=".4" height=".1" rx="0" fill="#111b54" />
        <rect x="12.3" y="19.1" width=".4" height=".1" rx="0" fill="#1159c9" />
        <rect x="12.3" y="19.1" width=".4" height=".1" rx="0" fill="#111b54" />
        <rect x="12.3" y="19.4" width=".4" height=".1" rx="0" fill="#1159c9" />
        <rect x="12.3" y="19.4" width=".4" height=".1" rx="0" fill="#111b54" />
        <path
          d="M5.4 3.6h-.7a.1.1 0 0 1-.1-.1v-.4h-.2a.1.1 0 0 1-.1-.1.1.1 0 0 1 0-.2l.7-.6a.1.1 0 0 1 .2 0l.7.6a.1.1 0 0 1 0 .2.1.1 0 0 1-.2 0h-.1v.5a.2.2 0 0 1-.2.1zm-.3-1.4l-.7.7h.3v.6h.7V3h.3l-.6-.7zM16.8 1h-3a.3.3 0 0 1 .3-.3.3.3 0 0 1 .2 0 .8.8 0 0 1 1.6-.1.5.5 0 0 1 .4-.2.5.5 0 0 1 .5.5V1zm-3 0h3a.5.5 0 0 0-.5-.5.5.5 0 0 0-.4 0 .8.8 0 0 0-.8-.5.8.8 0 0 0-.8.7.3.3 0 0 0-.2 0 .3.3 0 0 0-.3.2z"
          fill="#151586"
        />
        <path
          d="M15.3.9H15V.5h-.1l.2-.3.4.3h-.2v.2zm-.1-.6l-.3.3h.1v.2h.3V.6l-.1-.3z"
          fill="#151586"
        />
        <path
          d="M20.5 18.4h-3.7a.3.3 0 0 1 0-.1.4.4 0 0 1 .4-.4.4.4 0 0 1 .2 0 1 1 0 0 1 2-.1.6.6 0 0 1 .5-.2.6.6 0 0 1 .6.6.6.6 0 0 1 0 .2zm-3.7 0h3.7v-.1a.6.6 0 0 0-.6-.6.6.6 0 0 0-.4.2 1 1 0 0 0-2 .1.3.3 0 0 0-.3 0 .4.4 0 0 0-.4.3z"
          fill="#fbb03b"
        />
        <path
          d="M18.7 18.2h-.4V17.9h-.1-.1v-.1l.3-.4h.1l.4.4h-.2v.3zm-.2-.7l-.3.3h.1v.2h.3v-.2h.2l-.4-.4z"
          fill="#fbb03b"
        />
        <path fill="#34dce7" d="M0 3.3h10.1v.1H0z" opacity=".3" />
        <g opacity=".7">
          <path
            d="M0 3.3h10V9a.5.5 0 0 1-.4.5h-9A.5.5 0 0 1 0 9V3.3z"
            fill="#151586"
          />
          <path
            fill="#34dce7"
            d="M.9 4.6h5.4v1.9H.9zM.9 6.9h1.9v.6H.9zM3.1 6.9h3.2v.6H3.1zM6.6 4.6h2.9v.8H6.6zM.9 7.9h8.7v.8H.9zM6.6 5.7h2.9v1.9H6.6zM0 3.3h10.1v1H0z"
            opacity=".3"
          />
          <circle cx=".4" cy="3.8" r=".2" fill="#34dce7" opacity=".3" />
          <path
            d="M.4 4a.2.2 0 0 1-.2-.2.2.2 0 0 0 .2.2.2.2 0 0 0 .2-.2.2.2 0 0 1-.2.2z"
            fill="#34dce7"
          />
          <circle cx=".9" cy="3.8" r=".2" fill="#34dce7" opacity=".3" />
          <path
            d="M.9 4a.2.2 0 0 1-.2-.2.2.2 0 0 0 .2.2.2.2 0 0 0 .2-.2.2.2 0 0 1-.2.2z"
            fill="#34dce7"
          />
          <circle cx="1.4" cy="3.8" r=".2" fill="#34dce7" opacity=".3" />
          <path
            d="M1.4 4a.2.2 0 0 1-.2-.2.2.2 0 0 0 .2.2.2.2 0 0 0 .2-.2.2.2 0 0 1-.2.2z"
            fill="#34dce7"
          />
          <circle cx=".4" cy="3.8" r=".2" fill="#34dce7" />
          <circle cx=".9" cy="3.8" r=".2" fill="#dbff0e" />
          <circle cx="1.4" cy="3.8" r=".2" fill="#ff2995" />
          <rect
            x=".2"
            y="4.5"
            width=".3"
            height="4.6"
            rx=".2"
            fill="#34dce7"
            opacity=".3"
          />
          <rect x=".3" y="4.6" width=".1" height="1.2" rx=".1" fill="#34dce7" />
          <path
            d="M3.4 5H1h2.3zM4 5h-.4.4zM6 5H4.4 6zM3.9 5.2H1 4zM5.2 5.1h-1 1zM6 5.1h-.6.6zM4.5 5.5H1.2h3.3zM5.7 5.5h-.9 1zM6 5.7H3.5 6zM4.6 6H1h3.5zM6 6.3H3.6h2.6zM3.8 6.4H1.7h2zM2 5.7h-.9.9zM2.6 7H2h.6zM2.5 7.4H1.1h1.4zM3.5 7h-.3.3zM4 7h-.3.3zM4.5 7h-.3.3zM5 7h-.3.2S5 7 5 7zM5.4 7h-.3.3zM5.9 7h-.3.3zM3.4 7.3h-.2.2zM3.8 7.3h-.2.2zM4.2 7.3H4h.2zM4.6 7.3h-.2.2zM5 7.3h-.2.2zM5.4 7.3h-.2.2zM5.8 7.3h-.2.2zM1.3 8.5L1 8.3l.1-.2h.1l-.2.2.2.1zM1.4 8.5l-.1-.2.1-.2V8.4zM7.1 5.3L7 5l.2-.2L7 5l.2.2zM8.3 6H6.8h1.5zM7.4 6.1h-.6.6zM7.4 6.4h-.6.6zM7.4 6.7h-.6.6zM7.4 7h-.6.6zM9.1 6.3h-.4.4zM9.1 6.5h-.4.4zM9.1 6.6h-.4.4zM9.1 6.8h-.4.4zM9.1 7h-.4.4zM9.1 7h-.4.4zM9.1 7.3h-.4v-.1h.4zM9.1 7.4h-.4.4zM5.9 8.1h-4 4zM4.3 8.3H2h2.4zM4.3 8.6H2h2.4z"
            fill="#342ee7"
          />
        </g>
        <path
          d="M3.7 10.1h4.7v4a.5.5 0 0 1-.5.6H4.2a.5.5 0 0 1-.5-.6v-4z"
          fill="#93278f"
          opacity=".2"
        />
        <path
          fill="#93278f"
          d="M4.3 11.1h3.9v1.4H4.3zM4.3 12.8h1.4v.4H4.3zM5.9 12.8h2.3v.4H5.9z"
          opacity=".3"
        />
        <path fill="#93278f" d="M3.7 10.1h4.8v.7H3.7z" opacity=".2" />
        <circle cx="4" cy="10.5" r=".1" fill="#93278f" opacity=".3" />
        <path
          d="M4 10.6a.1.1 0 0 1-.1-.1.1.1 0 1 0 .3 0 .1.1 0 0 1-.2.1z"
          fill="#93278f"
        />
        <circle cx="4.3" cy="10.5" r=".1" fill="#93278f" opacity=".3" />
        <path
          d="M4.3 10.6a.1.1 0 0 1-.1-.1.1.1 0 1 0 .3 0 .1.1 0 0 1-.2.1z"
          fill="#93278f"
        />
        <circle cx="4.7" cy="10.5" r=".1" fill="#93278f" opacity=".3" />
        <path
          d="M4.7 10.6a.1.1 0 0 1-.2-.1.1.1 0 1 0 .3 0 .1.1 0 0 1-.1.1z"
          fill="#93278f"
        />
        <circle cx="4" cy="10.5" r=".1" fill="#93278f" />
        <circle cx="4.3" cy="10.5" r=".1" fill="#93278f" />
        <circle cx="4.7" cy="10.5" r=".1" fill="#93278f" />
        <rect
          x="3.9"
          y="11"
          width=".2"
          height="3.4"
          rx=".1"
          fill="#93278f"
          opacity=".3"
        />
        <rect x="3.9" y="11.1" width=".1" height=".9" rx="0" fill="#93278f" />
        <path
          d="M6.1 11.3H4.5 6zM6.5 11.3h-.2.3zM8 11.3H6.8 8zM6.5 11.5h-2 2zM7.5 11.5h-.8.8zM8 11.5h-.4.4zM7 11.7H4.5h2.3zM7.8 11.7h-.6.6zM8 11.9H6.2 8zM7 12.1H4.5 7zM8 12.3H6.3h1.9zM6.4 12.4H5h1.5zM5.2 11.9h-.7.7zM5.6 12.9H5h.5zM5.5 13h-1 1zM6.2 12.9H6h.2zM6.6 12.9h-.2.2zM7 12.9h-.3.2zM7.3 12.9H7h.2zM7.6 12.9h-.2.2zM8 12.9h-.2.2zM6.2 13H6h.1zM6.4 13zM6.7 13h-.1.1zM7 13h-.1.1zM7.3 13h-.1.1zM7.6 13h-.1s.1 0 0 0zM7.9 13h-.2.2zM4.6 13.9l-.1-.1.1-.2-.1.2h.1v.1zM4.7 13.9l-.1-.1.1-.2V14zM8 13.6H5h3zM6.8 13.8H5.1h1.7zM6.8 14H5.1h1.7z"
          fill="#93278f"
        />
        <path
          d="M17.1 12.6h3.8V14a.5.5 0 0 1-.5.5h-2.8a.5.5 0 0 1-.5-.5v-1.4z"
          fill="#ff551f"
          opacity=".3"
        />
        <path
          fill="#ff551f"
          d="M17.5 13.1h2.2v.8h-2.2zM17.1 12.6h3.8v.4h-3.8z"
          opacity=".3"
        />
        <circle cx="17.3" cy="12.8" r=".1" fill="#ff551f" opacity=".3" />
        <path d="M17.3 12.9l-.1-.1h.1z" fill="#ff551f" />
        <circle cx="17.5" cy="12.8" r=".1" fill="#ff551f" opacity=".3" />
        <path d="M17.5 12.9l-.1-.1h.1z" fill="#ff551f" />
        <circle cx="17.7" cy="12.8" r=".1" fill="#ff551f" opacity=".3" />
        <path d="M17.7 12.9v-.1h.1z" fill="#ff551f" />
        <circle cx="17.3" cy="12.8" r=".1" fill="#ff551f" />
        <circle cx="17.5" cy="12.8" r=".1" fill="#ff551f" />
        <circle cx="17.7" cy="12.8" r=".1" fill="#ff551f" />
        <rect
          x="17.2"
          y="13.1"
          width=".1"
          height="1.3"
          rx=".1"
          fill="#ff551f"
          opacity=".3"
        />
        <rect x="17.2" y="13.1" width=".1" height=".5" rx="0" fill="#ff551f" />
        <path
          d="M18.3 13.2zM18.4 13.2zM19.4 13.2zM18.4 13.3h-.8.8zM19.2 13.3h-.7.7zM19.4 13.3h-.2.2zM18.6 13.4zM19.3 13.4zM19.4 13.4h-1.1 1.1zM18.6 13.5h-1 1zM19.4 13.6zM18 13.6zM17.8 13.4h-.2.2z"
          fill="#ff551f"
        />
        <path
          d="M15.6 1.7h6.7v9.4a.5.5 0 0 1-.5.5h-5.7a.5.5 0 0 1-.6-.5V1.7z"
          fill="#151586"
          opacity=".3"
        />
        <path
          fill="#151586"
          d="M16.5 3h5.4v4.7h-5.4zM16.5 9h1.9v.6h-1.9zM18.6 9h3.2v.6h-3.2zM16.5 9.9h5.4v.8h-5.4zM15.6 1.7h6.8v1h-6.8z"
          opacity=".3"
        />
        <circle cx="16" cy="2.2" r=".2" fill="#151586" opacity=".3" />
        <path
          d="M16 2.4a.2.2 0 0 1-.2-.2.2.2 0 0 0 .2.2.2.2 0 0 0 .2-.2.2.2 0 0 1-.2.2z"
          fill="#151586"
        />
        <circle cx="16.5" cy="2.2" r=".2" fill="#151586" opacity=".3" />
        <path
          d="M16.5 2.4a.2.2 0 0 1-.2-.2.2.2 0 0 0 .2.2.2.2 0 0 0 .2-.2.2.2 0 0 1-.2.2z"
          fill="#151586"
        />
        <circle cx="16.9" cy="2.2" r=".2" fill="#151586" opacity=".3" />
        <path
          d="M17 2.4a.2.2 0 0 1-.2-.2.2.2 0 0 0 .2.2.2.2 0 0 0 .2-.2.2.2 0 0 1-.2.2z"
          fill="#151586"
        />
        <circle cx="16" cy="2.2" r=".2" fill="#151586" />
        <circle cx="16.5" cy="2.2" r=".2" fill="#151586" />
        <circle cx="16.9" cy="2.2" r=".2" fill="#151586" />
        <rect
          x="15.8"
          y="2.9"
          width=".3"
          height="8.3"
          rx=".2"
          fill="#151586"
          opacity=".3"
        />
        <rect
          x="15.9"
          y="3"
          width=".1"
          height="1.2"
          rx=".1"
          fill="#151586"
          opacity=".3"
        />
        <path
          fill="#151586"
          d="M16.7 3.3h2.2M19.1 3.3h.4M19.9 3.3h1.6M16.7 3.5h2.7M19.7 3.5h1.1M21 3.5h.6M16.8 3.8H20M20.4 3.8h.9M21.6 4.1h-2.5M20.1 4.4h-3.4M19.1 4.6h2.5M18.9 5.3h-2.2M16.7 4.1h.9M18.1 9.1h-.6M18.1 9.4h-1.5M18.8 9.1h.3M19.3 9.1h.2M19.8 9.1h.2M20.2 9.1h.3M20.7 9.1h.3M21.2 9.1h.2M18.8 9.3h.2M19.2 9.3h.2M19.6 9.3h.2M20 9.3h.1M20.4 9.3h.1M20.8 9.3h.1M21.1 9.3h.2M16.8 10.2l-.2.2.2.1M17 10.2l-.2.2.2.1"
        />
        <path
          fill="#151586"
          d="M18.6 5.7l-.5.4.4.4M19 5.7l-.4.4.4.4"
          opacity=".4"
        />
        <path fill="#151586" d="M17.5 10.2h3.9M17.5 10.3h2.4M17.5 10.6h2.4" />
        <circle cx="20.1" cy="5.9" r=".8" fill="#151586" opacity=".4" />
        <path d="M19.8 6.1a.3.3 0 0 0 .3.4.3.3 0 0 0 .3-.4z" fill="#151586" />
        <path
          d="M19.6 5.8a.2.2 0 0 1 .2-.2.2.2 0 0 1 .1.2"
          fill="#151586"
          opacity=".4"
        />
        <path d="M20.3 5.8a.2.2 0 1 1 .3 0M20.8 6.7h.7" fill="#151586" />
        <path
          d="M20.1 12a.4.4 0 0 1-.4-.3.4.4 0 1 1 .9 0 .4.4 0 0 1-.5.4zm0-.7a.3.3 0 1 0 0 .7.3.3 0 1 0 0-.7z"
          fill="#fbb03b"
        />
        <path
          d="M2.2 11.3a.4.4 0 0 1 0-.8.4.4 0 1 1 0 .8zm0-.8a.3.3 0 0 0-.3.4.3.3 0 0 0 .3.3.3.3 0 0 0 .4-.3.3.3 0 0 0-.4-.3z"
          fill="#151586"
        />
        <path fill="#fbb03b" d="M10.4 2.5l1 .8h-.1z" />
        <path
          fill="#fbb03b"
          d="M10.4 3.2l.9-.8-.8.9zM6.3 19.3l-1-1 1-1 1 1zm-.8-1l.8.8.7-.8-.8-.8zM2.5 14.4l-1-1 1-1 1 1zm-.8-1l.8.8.8-.8-.8-.8zM13.7 3.3l-1-1 1-1 1 1zm-.8-1l.8.8.8-.8-.8-.7z"
        />
        <path
          d="M22.2 15.1l-.5-.4.5-.5.5.5zm-.4-.4l.4.3.4-.3-.4-.4z"
          fill="#151586"
        />
        <path
          d="M20 15.4l-.6-.5.5-.5.5.5zm-.5-.5l.4.4.4-.4-.4-.4z"
          fill="#fbb03b"
        />
        <path fill="#151586" d="M24.2 10.4l-.6-.6.6-.6-.5.6.5.5z" />
        <path
          fill="#151586"
          d="M24.6 10.4l-.6-.6.6-.6-.4.6.5.5h-.1zM5.1 10l-.6-.5.6-.6-.4.6.5.5H5z"
        />
        <path fill="#151586" d="M5.5 10L5 9.6l.5-.6-.4.6.5.5z" />
        <path fill="#fbb03b" d="M14.2 6l-.6-.5.6-.6-.5.6.5.5z" />
        <path
          fill="#fbb03b"
          d="M14.6 6l-.6-.5.6-.6-.5.6.6.5h-.1zM11.7 5.5h-.4v-.3H11a.1.1 0 0 1 0-.2l.4-.4.5.4v.1h-.2v.3a.1.1 0 0 1 0 .1zm-.2-.8l-.4.4h.2v.3h.4V5h.2l-.4-.4zM5.5 15.3h-.4V15h-.2v-.2l.3-.4a.1.1 0 0 1 .2 0l.4.4-.1.2v.2a.1.1 0 0 1-.2.2zm-.2-.8l-.4.4h.2v.3h.4v-.3h.2l-.4-.4z"
        />
      </g>
    </g>
  </svg>
);

export default Badge;



// WEBPACK FOOTER //
// ./src/components/SVG/Badge4.js